import IMask from 'imask/holder';
import 'imask/masked/pattern';

export const createInputMask = (input, options) => {
    return IMask(input, options);
};
